import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

type Variant = 'primary' | 'secondary' | 'danger';
type Size = 'sm' | 'md' | 'lg';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  loading?: boolean;
}

const base =
  'inline-flex items-center gap-2 rounded px-3 py-2 text-sm font-medium ' +
  'disabled:opacity-50 disabled:cursor-not-allowed transition-colors';

const variants: Record<Variant, string> = {
  primary:   'bg-brand text-white hover:bg-brand/90',
  secondary: 'border border-brand text-brand hover:bg-brand/10 dark:border-brand/60 dark:text-brand/80',
  danger:    'bg-red-600 text-white hover:bg-red-700',
};

const sizes: Record<Size, string> = {
  sm: 'px-2 py-1 text-xs',
  md: 'px-3 py-2 text-sm',
  lg: 'px-4 py-3 text-base',
};

export const Button = forwardRef<HTMLButtonElement, Props>(({
  variant = 'primary',
  size = 'md',
  loading,
  children,
  className,
  ...rest
}, ref) => (
  <button
    ref={ref}
    className={clsx(base, variants[variant], sizes[size], className)}
    disabled={loading || rest.disabled}
    {...rest}
  >
    {loading && (
      <span className="animate-spin h-4 w-4 rounded-full border-2 border-white/50 border-t-transparent" />
    )}
    {children}
  </button>
)); 